export default {
    container: {
        width: '500px',
    },
    checkbox: {
        margin: '0 0 0 50px',
    },
    formElement: {
        display: 'block',
        marginBottom: '20px',
        width: '100%',
    },
    buttons: {
        display: 'flex',
        marginTop: '40px',
        width: '400px',
        alignItems: 'center',
    },
    cardActionStyle: {
        zIndex: 2,
        display: 'inline-block',
        float: 'right',
    },
};



// WEBPACK FOOTER //
// ./src/pages/products/productProperties/create/styles.js